import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from '../../services/environment.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.html',
  styleUrls: ['./footer.scss']
})

export class FooterComponent implements OnInit {

  readonly startYear = 2018;
  yearsRange: string;
  termsUrl: string;

  constructor(private envSvc: EnvironmentService) {
    let currentYear = (new Date()).getFullYear();
    this.yearsRange = (currentYear > this.startYear ? this.startYear + '-' : '') + currentYear;
    
    // Set Terms & Conditions URL - CyberSweep has custom URL, others use generic
    try {
      const product = this.envSvc.getProductFromSubdomain();
      if (product === 'cybersweep') {
        this.termsUrl = 'https://regalcredit.com/cybersweep-tos/';
      } else {
        this.termsUrl = 'https://regalcredit.com/terms-and-conditions/';
      }
    } catch (e) {
      // Fallback to generic URL if product detection fails
      this.termsUrl = 'https://regalcredit.com/terms-and-conditions/';
    }
  }

  ngOnInit() {
  }
}
